/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListPipelineParams = {
stage_id?: string | null;
search?: string | null;
sort_by?: string | null;
sort_order?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
cursor?: string | null;
view?: 'picker' | null;
};
